var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyGameplan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 22,
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 50c-13.78 0-25 11.22-25 25 0 4.88 1.08 8.75 3.6 12.92a1.73 1.73 0 0 0 2.96-1.78A20 20 0 0 1 53.46 75 21.57 21.57 0 0 1 75 53.45 21.57 21.57 0 0 1 96.55 75 21.57 21.57 0 0 1 75 96.55c-6.09 0-10.33-2.3-12.82-4.22a1.72 1.72 0 1 0-2.12 2.71A24.2 24.2 0 0 0 75 100c13.78 0 25-11.22 25-25S88.78 50 75 50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.77 86.98l14.82-6.5c.14-.08.3-.18.41-.3.03-.03.08-.05.1-.08.15-.14.27-.34.37-.54v-.02l6.2-14.62c.26-.64.11-1.4-.38-1.9-.5-.5-1.26-.64-1.9-.37l-14.5 6.28-.02.03c-.2.1-.4.22-.54.37-.03.02-.03.05-.05.07-.12.15-.25.3-.32.45v.05L62.5 84.7c-.3.65-.15 1.4.37 1.9.32.32.76.52 1.2.52.23 0 .48-.05.7-.15zM78.3 75.86l-4.73-4.73 8.28-3.58-3.55 8.31zm-7.17-2.29l4.78 4.78-8.5 3.7 3.72-8.48z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGameplan);
export default __webpack_public_path__ + "static/media/empty-gameplan.9ad8823c.svg";
export { ForwardRef as ReactComponent };